import React from 'react';

import Button, { Props as ButtonProps } from '@ott/button';
import ErrorIcon from '@ott/icon-error';
import { l10n } from '@ott/l10n';
import Modal, { CONTENT_SIZE } from '@ott/modal';

import styles from './ErrorModal.scss';

type Props = {
  isOpen?: boolean;
  title?: string;
  icon?: JSX.Element;
  description?: string;
  actionButtonText?: string;
  actionButtonPurpose?: ButtonProps['purpose'];
  preventUserCloseModal?: boolean;
  onClose: VoidFunction;
  onAction: VoidFunction;
};

const ErrorModal = ({
  isOpen = true,
  icon = <ErrorIcon />,
  title = l10n('virtualCard.errors.serverError.title'),
  description = l10n('virtualCard.errors.serverError.description'),
  actionButtonText = l10n('virtualCard.errors.serverError.action'),
  actionButtonPurpose = 'defaultPurpose',
  preventUserCloseModal,
  onClose,
  onAction,
}: Props) => {
  return (
    <Modal
      specificLocators="error-modal"
      isOpen={isOpen}
      fullScreenOnMobile={true}
      contentOptions={{
        size: CONTENT_SIZE.SMALL,
        icon,
        title,
        footerContentNode: (
          <Button
            purpose={actionButtonPurpose}
            withFullWidth={true}
            onClick={onAction}
            specificLocators="error-modal-action-button"
          >
            {actionButtonText}
          </Button>
        ),
      }}
      preventUserClose={preventUserCloseModal}
      onClose={onClose}
    >
      <div className={styles.description}>{description}</div>
    </Modal>
  );
};

export default React.memo(ErrorModal);
